import { createFileRoute } from '@tanstack/react-router';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { ServiceNoteForm } from '~/components/deliveries/serviceNoteForm';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.pageTitle.createService, { ns: 'delivery' });

export const Route = createFileRoute(
  '/(main)/deliveries/all/create-service-note/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/deliveries/all/create-service-note/',
    ...routeParams,
  }),
  component: ServiceNoteForm,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const CREATE_SERVICE_NOTE = buildRouteExport({
  Route,
  ...routeParams,
});
